import { tabs } from '@/pages/shipment/PharmacistShipments';
import { Tab } from '@montugroup/design-system';
import { styled, Tabs } from '@mui/material';

const PharmacistShipmentsTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  fontFamily: theme.typography.button.fontFamily,
  '&:focus': {
    outline: 'none',
  },
  '&:focus-visible': {
    outline: 'auto',
  },
}));

interface IPharmacistShipmentsTabsProps {
  activeTab: string;
  toggleTab: (tab: string) => void;
}

function PharmacistShipmentsTabs({ activeTab, toggleTab }: IPharmacistShipmentsTabsProps) {
  return (
    <Tabs
      value={activeTab}
      onChange={(_event, newView) => toggleTab(newView)}
      textColor="secondary"
      indicatorColor="secondary"
    >
      {/* TODO: B2B-7860 - add this tab */}
      <PharmacistShipmentsTab label="Warehouse Orders" value={tabs.WAREHOUSE_ORDERS} />
      <PharmacistShipmentsTab label="Controlled Drug Receipts" value={tabs.SHIPMENTS} />
    </Tabs>
  );
}

export default PharmacistShipmentsTabs;
